import {createSelector} from '@ngrx/store';

import {PROFILE_FEATURE_KEY, selectAuthFeature} from '../reducers';

export const selectUserProfile = createSelector(
  selectAuthFeature,
  (state) => state[PROFILE_FEATURE_KEY]
);
